<template>
	<div>
		<TopBanner
			contentWidth="1400"
			height="300"
			versionName=""
			versionNameVerticalAlign="16"
			versionNameShow="1"
			styleApi="padding-top"
			logoMargin="109"
			headerBackgroundImg="bannerback.png"
		>
			<!-- 顶部导航插槽：登录/忘记密码/注册等链接 -->
			<template v-slot:topBannerNav>
				<topNavigation
					:deleteSort="[2, 1]"
					:defalutSort="[4, 5, 2, 1]"
					:alginRight="true"
					:addNavListLeft="[
						{
							name: '产品介绍',
							toLink: '/about',
						},
					]"
				></topNavigation>
			</template>
			<template slot="topBannerContent">
				<!-- :selectType="getadv ? '1,3,0,2,4' : '1,3,0'" 这里区分机构用户和个人用户，9.15去掉这个逻辑 改成一样的 -->
				<Search
					class="add"
					searchPosition="1"
					:selectType="getadv ? '1,3,0' : '1,3,0'"
					keyWordsInputTab="请输入关键词"
					searchUrl="4,0,96"
					heighSearchUrl="2,51210"
					searchBoxWidth="610,0"
					searchInputWidth="295,0"
					inputAndSelectWrapWidth="371,0"
					simpleSearchIcon=""
					simpleSearchButton="38,20,#1278de,20,14"
					heighSearchButton="38,50,#17c0c6,20,14"
				>
					<template v-slot:aiBtn>
						<a
							@click="searchGoAi()"
							target="blank"
							class="searchbtnb aibtnb"
							>AI检索</a
						>
					</template>
				</Search>
			</template>
		</TopBanner>

		<!-- 移动端内容（从 topNavigation 拷贝出来，避开嵌套插槽作用域问题） -->
		<div v-if="isMoblie">
			<!-- 左上角悬浮导航按钮 -->
			<Icon
				class="drawer-button"
				name="list-switch"
				size="30"
				@click.stop="toggleMobileDrawer"
			/>
			<!-- 抽屉弹窗 -->
			<Popup
				v-model="mobileDrawerOpen"
				position="right"
				:style="{ height: '100%', minWidth: '310px' }"
			>
				<!-- 登录信息 -->
				<div class="drawer-content">
					<div class="userInfos">
						<div
							v-show="isShowLogin"
							@click="isMobileLoginTo"
							class="userInfosLogin"
						>
							登录
						</div>
						<div v-show="isShowName" class="userInfosInfo">
							欢迎您，{{ userName }}
						</div>
						<div
							v-if="isShowName"
							@click="loginOut"
							v-show="isShowName"
							class="userInfosOut"
						>
							退出
						</div>
						<div
							v-show="isShowLogin"
							class="userInfosPass"
							@click="
								regLink(
									'http://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserPwdGet.aspx',
								)
							"
						>
							忘记密码
						</div>
						<div
							v-show="isShowLogin"
							class="userInfosReg"
							@click="
								regLink('https://user.drcnet.com.cn/#/regist')
							"
						>
							注册
						</div>
					</div>
				</div>
				<!-- homeNavIsMoblie 放在抽屉 bottom 位置 -->
				<homeNavIsMoblie style="width: 310px"></homeNavIsMoblie>
			</Popup>
		</div>

		<homeNav v-if="isMoblie == false"></homeNav>
		<appMain></appMain>
		<footers></footers>
		<BackTop></BackTop>
	</div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import BackTop from './components/backTop';
import { Popup, Icon } from 'vant';
import {
	getName,
	setName,
	removeuserId,
	removeName,
	getToken,
	setToken,
	removeToken,
	getAdv,
	setAdv,
	removeAdv,
} from '@/utils/infomationStorage';
import { jsonp } from 'vue-jsonp';
import topNavigation from '@/components/topNavigation.vue';
import TopBanner from './components/TopBanner';
import appMain from './components/appMain.vue';
import homeNav from './components/homeNav.vue';
import homeNavIsMoblie from './components/homeNavIsMoblie.vue';
import footers from './components/footer.vue';
import Search from '@/components/Search';
export default {
	name: '',
	components: {
		topNavigation,
		TopBanner,
		Popup,
		Icon,
		homeNav,
		footers,
		appMain,
		Search,
		homeNavIsMoblie,
		BackTop,
	},
	mixins: [],
	props: {},
	data() {
		return {
			assemblyList: [],
			isMoblie: false,
			getadv: getAdv(),
			// 移动端抽屉
			mobileDrawerOpen: false,
			isShowLogin: true,
			isShowName: false,
			userName: '',
			loginUrl: '',
		};
	},
	computed: {
		...mapState(['userToken']),
		...mapState(['uid']),
	},
	watch: {
		MobileVerification: {
			handler(to) {
				this.isMoblie = to;
			},
			immediate: true,
		},
	},
	created() {
		this.logenter();
	},
	mounted() {},
	methods: {
		searchGoAi() {
			window.open('https://search.drcnet.com.cn/aiSearch');
		},
		// 抽屉切换
		toggleMobileDrawer() {
			this.mobileDrawerOpen = !this.mobileDrawerOpen;
		},
		// 登录
		login() {
			let url = 'https://user.drcnet.com.cn/#/login';
			this.loginUrl =
				url +
				'?gourl=' +
				window.location.href.replace('?', '~~').replace('&', '^');
		},
		// 移动端登录
		isMobileLoginTo() {
			this.login();
			window.location.href = this.loginUrl;
		},
		// 链接跳转
		regLink(link) {
			window.open(link);
		},
		// 退出登录
		loginOut() {
			let loginUrl =
				'http://user.drcnet.com.cn/userapi/loginController/logOutAllP';
			let _this = this;
			jsonp(loginUrl, { randomId: this.getRandom() })
				.then(() => {
					_this.$nextTick(() => {
						removeuserId();
						removeName();
						removeToken();
						removeAdv();
						_this.updateUserName('defaultname');
						_this.updateUserToken('notoken');
						_this.isShowLogin = true;
						_this.isShowName = false;
						_this.$router.go(0);
					});
				})
				.catch(() => {
					_this.$nextTick(() => {
						removeuserId();
						removeName();
						removeToken();
						removeAdv();
						_this.updateUserName('defaultname');
						_this.updateUserToken('notoken');
						_this.isShowLogin = true;
						_this.isShowName = false;
						_this.$router.go(0);
					});
				});
		},
		// 登录态查询
		logenter() {
			let loginUrl =
				'http://user.drcnet.com.cn/userapi/loginController/initLoginP';
			jsonp(loginUrl, { flag: 'initp', randomId: this.getRandom() })
				.then((res) => {
					if (res.Logined === 1) {
						setName(res.UserName);
						setToken(res.UserToken);
						setAdv(res.IsAdv);
						this.updateUserName(res.UserName);
						this.updateUserToken(res.UserToken);
						this.isShowLogin = false;
						this.isShowName = true;
						this.userName = getName();
					} else {
						removeName();
						removeToken();
						removeAdv();
						this.updateUserName('defaultname');
						this.updateUserToken('notoken');
						this.isShowLogin = true;
						this.isShowName = false;
					}
				})
				.catch(() => {});
		},
		// 时间戳+随机数
		getRandom() {
			let timestamp = Date.now();
			let randomNum = Math.random();
			return timestamp + '_' + randomNum.toFixed(6);
		},
		...mapMutations(['updateUserName']),
		...mapMutations(['updateUserToken']),
	},
	beforeDestroy() {
		this.$eventBus.$off('bustype1');
		this.$eventBus.$off('literatureList');
		this.$eventBus.$off('upLists');
	},
};
</script>
<style lang="less" scoped>
.add {
	position: absolute;
	right: 0;
	bottom: -60px;
}
::v-deep .home {
	width: 1400px !important;
}
::v-deep .header-nav {
	top: 0px !important;
}
::v-deep .toplogin .nav-top li a {
	color: #000000 !important;
	border-right-color: #000000 !important;
	border-right-width: 1px;
}
::v-deep .toplogin {
	background: transparent !important;
	border: 0px;
}
::v-deep .searchbox {
	.aibtnb {
		height: 38px;
		line-height: 38px;
		background: #e6a23c;
		padding: 0px 15px;
		font-size: 14px;
		margin-left: 1px;
	}
}

/* 移动端抽屉按钮 */
.drawer-button {
	position: fixed;
	top: 20px;
	right: 20px;
	background: transparent;
	border: none;
	cursor: pointer;
	font-size: 24px;
	z-index: 100;
}

/* 移动端抽屉用户信息 */
.drawer-content {
	.userInfos {
		display: flex;
		padding: 10px 10px 20px;
		font-size: 16px;
		color: #1a1a1a;
		border-bottom: 1px solid #ececec;
	}
	.userInfosLogin {
		width: 33%;
	}
	.userInfosInfo {
		width: 70%;
		max-width: 203px;
		margin-right: 10px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: inline-block;
	}
	.userInfosOut {
		width: 20%;
	}
	.userInfosPass {
		width: 43%;
	}
	.userInfosReg {
		width: 33%;
	}
}
::v-deep .toplogin .nav-top li a {
	/* 柔和发光描边：先来 1px 锐利描边垫底，再叠多层模糊光晕从外到内衰减 */
	text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,
		1px 1px 0 #fff, 0 0 2px rgba(255, 255, 255, 0.95),
		0 0 4px rgba(255, 255, 255, 0.85), 0 0 8px rgba(255, 255, 255, 0.65),
		0 0 14px rgba(255, 255, 255, 0.45);
}
::v-deep .toplogin .nav-top li span {
	/* 柔和发光描边：先来 1px 锐利描边垫底，再叠多层模糊光晕从外到内衰减 */
	text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,
		1px 1px 0 #fff, 0 0 2px rgba(255, 255, 255, 0.95),
		0 0 4px rgba(255, 255, 255, 0.85), 0 0 8px rgba(255, 255, 255, 0.65),
		0 0 14px rgba(255, 255, 255, 0.45);
}
@media screen and (max-width: 769px) {
	.add {
		position: absolute;
		right: 0;
		top: 112px !important;
		bottom: 0px !important;
		display: flex;
	}

	.header {
		// height: 144px !important;
	}
	::v-deep .search.search {
		width: calc(100% - 80px) !important;
	}
	::v-deep .searchbtnb {
		display: none !important;
	}
}
</style>
